import React, { useEffect, useState } from "react";
import "./ResourcesPage.css";
import { FaDownload, FaFilePdf, FaVideo, FaTimes } from "react-icons/fa";
import bannerBg from "../../assets/images/main-banner -new.png";
import rightBannerImage from "../../assets/images/certificate.png";
import demoVideo from "../../assets/images/video-six.mp4";

const technicalSpecs = [
  { feature: "Model", value: "PulsOjet Disposable Pulse Lavage System" },
  { feature: "Power Source", value: "Inbuilt Battery" },
  {
    feature: "Battery Life",
    value: "Single-use, optimized for full surgical procedure",
  },
  {
    feature: "Flow Rate",
    value: "High Mode: 1200 ml/min, Low Mode: 700 ml/min",
  },
  { feature: "Pressure Range", value: "Up to 15 Psi" },
  { feature: "Sterility", value: "Gamma Sterilized / EO Sterilized" },
  { feature: "Disposable Components", value: "Handpiece, tubing, nozzle" },
  { feature: "Weight", value: "< 0.5 kg (lightweight design)" },
  {
    feature: "Nozzle Attachments",
    value: "Cone tip & coaxial canal tip for precision irrigation",
  },
  { feature: "Tubing Length", value: "Approx 3 meters" },
];

const downloads = [
  {
    icon: <FaFilePdf />,
    title: "Pulsojet Brochure",
    description: "Comprehensive product overview and technical details.",
    file: "/pulsojet-brochure.pdf",
    size: "2.4 MB",
    type: "pdf",
  },
  {
    icon: <FaFilePdf />,
    title: "Instructions for Use (IFU)",
    description: "Step-by-step guidance for safe and effective usage.",
    file: "/pulsojet-ifu.pdf",
    size: "1.1 MB",
    type: "pdf",
  },
  {
    icon: <FaVideo />,
    title: "Watch Demo Video",
    description: "See how Pulsojet works in real time.",
    file: demoVideo,
    size: "2 min",
    type: "video",
  },
];

const ResourcesPage = () => {
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    document.title = "Resources & Download - PulsOjet®";
  }, []);

  const handleVideoOpen = () => setShowVideo(true);
  const handleVideoClose = () => setShowVideo(false);

  return (
    <div className="resources-page">
      {/* Banner Section */}
      <div
        className="banner-wrpper-max"
        style={{ backgroundImage: `url(${bannerBg})` }}
      >
        <section className="banner">
          <div className="banner-overlay">
            <div className="banner-content">
              <div className="banner-text">
                <h1>
                  Product Documentation{" "}
                  <span className="line-break line-breaking-box">
                    & Technical Resources
                  </span>
                </h1>
                <p>
                  <span className="line-break">
                    Everything you need — from technical specifications to
                    regulatory documentation — in one place.
                  </span>
                </p>
              </div>
            </div>
            <div className="banner-sidebar">
              <img src={rightBannerImage} alt="Right Banner Device" />
            </div>
          </div>
        </section>
      </div>

      {/* Section 2: Technical Specs */}
      <section className="specs-section">
        <h2 className="section-title">Technical Specifications</h2>
        <table className="specs-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Specification</th>
            </tr>
          </thead>
          <tbody>
            {technicalSpecs.map((spec, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? "even" : "odd"}>
                <td className="feature">{spec.feature}</td>
                <td className="value">{spec.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* Section 3: Downloads & Media */}
      <section className="downloads-section">
        <h2 className="section-title">Downloads & Media</h2>
        <div className="downloads-grid">
          {downloads.map((doc, index) => (
            <div className="download-card" key={index}>
              <div className="icon">{doc.icon}</div>
              <h3>{doc.title}</h3>
              <p>{doc.description}</p>

              {doc.type === "video" ? (
                <button onClick={handleVideoOpen} className="download-btn">
                  <FaVideo /> Watch <span className="size">({doc.size})</span>
                </button>
              ) : (
                <a
                  href={doc.file}
                  className="download-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaDownload /> View <span className="size">({doc.size})</span>
                </a>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Video Modal */}
      {showVideo && (
        <div className="video-modal-overlay" onClick={handleVideoClose}>
          <div className="video-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={handleVideoClose}>
              <FaTimes />
            </button>
            <video
              src={demoVideo}
              controls
              autoPlay
              style={{ width: "100%" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ResourcesPage;
